import React from 'react';
import { Tag, Row, Space, Button, Input, DatePicker, Select, Table, Pagination, Checkbox, Modal, Transfer, message, Divider, Rate, Popover } from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { CloseOutlined } from '@ant-design/icons'
import { StarOutlined, PlusCircleOutlined, FormOutlined, MobileOutlined, PhoneOutlined, WechatOutlined, MailOutlined, HomeOutlined, GlobalOutlined, FolderOpenOutlined, UserOutlined, HistoryOutlined, SearchOutlined, QrcodeOutlined } from '@ant-design/icons'
import moment from 'moment';
import Remark from "../public/remark";
import JfPlan from "../public/jf_plan";

const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;
class DwView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {

            },
            visible: false,
        };
        this.mingpian = React.createRef();
        this.genjin = React.createRef();
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }
    componentDidMount() {


    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            that.getdata()
        } else {
            that.setState({
                condition: {

                },
            })
        }
    }
    getdata() {
        let that = this
        let arr = {}
        arr.id = that.props.id
        arr.type = 3
        fetch('/Pay/detail', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    condition: data.data
                })
            })
    }
    arrfjlist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <div key={index}>
                    <a href={item.url} download={item.name}>
                        {item.name}
                    </a>
                </div>
            )
        }
    }
    render() {
        const columns2 = [
            {
                title: '缴费金额',
                dataIndex: 'aid',
                key: 'aid',
            }, {
                title: '缴费时间',
                dataIndex: 'aid',
                key: 'aid',
                width: 120,
            }, {
                title: '处理状态',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 100,
                render: (row, record) => {
                    return (<>
                        <Tag>{row}</Tag>
                    </>)
                },
            },]

        return (
            <>
                {this.props.title ? <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)} >{this.props.title}</a> : <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)} >查看</a>}

                <Modal title="查看详情" destroyOnClose={true} bodyStyle={{padding:15}} width={800} visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <div className={'view_box'}>
                        <div className={'view_title'}>合同信息</div>
                        <div className={'view_info'}>
                            <div className={'item'}>
                                <div className={'p1'}>企业名称</div>
                                <div className={'p2'}>{this.state.condition.company_name}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>合同编号</div>
                                <div className={'p2'}>{this.state.condition.ref}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>租赁时间</div>
                                <div className={'p2'}>{this.state.condition.zltime}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>租赁时长</div>
                                <div className={'p2'}>{this.state.condition.duration}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>免租期时间</div>
                                <div className={'p2'}>{this.state.condition.mz_stime}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>免租期月数</div>
                                <div className={'p2'}>{this.state.condition.mz_duration}</div>
                            </div>
                            <div className={'item all'}>
                                <div className={'p1'}>免租期月度应收管理服务费</div>
                                <div className={'p2'}>{this.state.condition.mz_service}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>正常期时间</div>
                                <div className={'p2'}>{this.state.condition.zc_stime}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>正常期月数</div>
                                <div className={'p2'}>{this.state.condition.zc_duration}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>正常期月度应收租赁费</div>
                                <div className={'p2'}>{this.state.condition.rent}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>正常期月度应收管理服务费</div>
                                <div className={'p2'}>{this.state.condition.service}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>制冷费</div>
                                <div className={'p2'}>{this.state.condition.zlcost}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>采暖费</div>
                                <div className={'p2'}>{this.state.condition.cncost}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>保证金</div>
                                <div className={'p2'}>{this.state.condition.guarantee}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>装修保证金</div>
                                <div className={'p2'}>{this.state.condition.zx_guarantee}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>合同附件</div>
                                <div className={'p2'}>
                                    <Space wrap direction={"vertical"}>
                                        {this.arrfjlist(this.state.condition.fjlist)}
                                    </Space>
                                </div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>合同状态</div>
                                <div className={'p2'}>
                                    {this.state.condition.status == 1 && <Tag color={'green'}>{this.state.condition.status_text}</Tag>}
                                    {this.state.condition.status == 2 && <Tag color={'red'}>{this.state.condition.status_text}</Tag>}
                                </div>
                            </div>
                        </div>
                        <div className={'view_title'}>企业信息</div>
                        <div className={'view_info'}>
                            <div className={'item'}>
                                <div className={'p1'}>企业名称</div>
                                <div className={'p2'}>{this.state.condition.company_name}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>法定代表人</div>
                                <div className={'p2'}>{this.state.condition.corporation}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>日常联系人</div>
                                <div className={'p2'}>{this.state.condition.contacts}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>日常联系人电话</div>
                                <div className={'p2'}>{this.state.condition.phone}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>紧急联系人</div>
                                <div className={'p2'}>{this.state.condition.emcontacts}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>紧急联系人电话</div>
                                <div className={'p2'}>{this.state.condition.emphone}</div>
                            </div>
                        </div>
                        <JfPlan id={this.props.id} type={3} title={'历史缴费记录'} />
                        <Remark id={this.props.id} type={3} cate={2} />
                    </div>
                </Modal>
            </>
        )
    }
}
export default DwView
